import { Badge, Button } from "@/components/common";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MotionLink = motion(Link);

const serviceCards = [
  {
    title: "문자콜센터 서비스",
    description:
      "흩어져 있는 고객 상담, 이제 한 곳에서 관리하세요. 자유롭게 설정하는 스마트 ARS 부터 웹 상담 채팅까지, 코드 한 줄로 빠르게 구축됩니다.",
    image: "/img/main/main_webcallcenter_service_img.png",
    accent: "#EEF1F4",
    accentSoft: "#f3efff",
    to: "/service-provide/voucher-aicc",
    chips: [
      { label: "통합 상담 플랫폼", to: "/business/admin" },
      { label: "스마트 ARS 설정", to: "/business/asp" },
      { label: "웹 채팅 상담", to: "/business/aicc" },
    ],
  },
  {
    title: "메시징 서비스",
    description:
      "문자메시지부터 알림톡/브랜드메시지, RCS(차세대 메시징)까지 보장된 기술로 가장 빠르고 정확하게 메시지를 전송하세요.",
    image: "/img/main/main_massaging_service_img.png",
    accent: "#EEF1F4",
    accentSoft: "#eaf2ff",
    to: "/service-provide/messaging",
    chips: [{ label: "문자" }, { label: "알림톡/브랜드메시지" }, { label: "RCS(차세대 메시징)" }],
  },
];

const MainServiceSection = () => {
  return (
    <section className="bg-[#f6f9ff] py-12 sm:py-10 px-[2rem] wide:px-0">
      <div className="mx-auto max-w-container sm:px-0">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="flex flex-col gap-5 mb-3 sm:mb-12 sm:flex-row  sm:items-end sm:justify-between"
        >
          <div>
            <p className="text-[2.5rem] font-medium text-[#2A2A2F]">
              1. 한 눈에 보는 <b>대표 서비스</b>
            </p>
          </div>
        </motion.div>

        <div className="grid gap-[4rem] lg:grid-cols-2">
          {serviceCards.map((card, index) => (
            <MotionLink
              key={card.title}
              to={card.to}
              initial={{ opacity: 0, y: 1 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              whileHover={{ y: -2 }}
              transition={{
                duration: 0.25,
                delay: index * 0.08,
                ease: "easeOut",
              }}
              className="overflow-hidden rounded-[2.8rem] border border-white bg-white p-5 shadow-[0_16px_30px_rgba(31,71,136,0.10)] sm:p-6 transition-shadow hover:shadow-lg"
            >
              <div
                className="relative overflow-hidden rounded-[2.2rem] px-4 sm:px-8"
                style={{
                  background: `linear-gradient(180deg, ${card.accentSoft} 0%, #ffffff 100%)`,
                }}
              >
                <div
                  className="absolute inset-0 opacity-70"
                  style={{
                    background: `radial-gradient(circle at center, ${card.accent}22 0%, transparent 68%)`,
                  }}
                />
                <img
                  src={card.image}
                  alt={card.title}
                  className="relative z-10 mx-auto w-auto sm:h-[20rem]"
                />
              </div>

              <div className="px-4 pt-6 pb-2">
                <h2 className="text-[3rem] font-bold tracking-[-0.03em] text-[#1f2738] sm:text-[3.2rem]">
                  {card.title}
                </h2>
                <p className="mt-2 text-[1.5rem] break-keep leading-[1.5] text-[#66748c] sm:text-[1.8rem]">
                  {card.description}
                </p>
                <div className="flex flex-wrap gap-3 mt-6">
                  {card.chips.map(chip => (
                    <Badge
                      key={chip.label}
                      size="sm"
                      className="rounded-full px-4 py-3 text-[1.5rem] font-semibold text-[#4D4E52]"
                      bg={card.accent}
                    >
                      {chip.label}
                    </Badge>
                  ))}
                </div>
              </div>
            </MotionLink>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainServiceSection;
